export default __webpack_public_path__ + "static/media/apvs-material-3.be07f51d.webp";